import React from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";

function ChangeDetailsLeftCard({ changelog }) {

    let date = ''
    let time = ''

    if (changelog.date) {
        const dateParts = changelog.date.split('T');
        date = dateParts[0];
        time = dateParts[1];
    }

    return (
        <div className="oct_description-list-card flex-grow-1">
            <ul className="oct_list list-unstyled">
                <li className="oct_item">
                    <span className="oct_title">Date:</span>
                    <span className="oct_specification">{date}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Time:</span>
                    <span className="oct_specification">{time}</span>
                </li>

                <li className="oct_item">
                    <span className="oct_title">Hostname:</span>
                    <span className="oct_specification">{changelog.hostName}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Serial Number:</span>
                    <span className="oct_specification">{changelog.serialNumber}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">MNGT IP Address:</span>
                    <span className="oct_specification">{changelog.mngtIpAddress}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Client IP Address:</span>
                    <span className="oct_specification">{changelog.clientIpAddress}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Username:</span>
                    <span className="oct_specification">{changelog.username}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Event ID:</span>
                    <span className="oct_specification">{changelog.eventId}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Event Message:</span>
                    <span className="oct_specification">{changelog.eventMessage}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Command:</span>
                    <span className="oct_specification">{changelog.command}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Configuration Path:</span>
                    <span className="oct_specification">{changelog.configurationPath}</span>
                </li>
                <li className="oct_item">
                    <span className="oct_title">Result:</span>
                    <span className="oct_specification">{changelog.result}</span>
                </li>
            </ul>


        </div>
    )

}

function mapStateToProps(state) {
    debug("ChangeDetailsLeftCard mapStateToProps", state);
    const changeDetailsPage = state.changeDetailsPage;
    return {
        changelog: changeDetailsPage.changelog || {}
    };
}

export default connect(mapStateToProps)(ChangeDetailsLeftCard);
